import { styled } from '@mui/material';
import { CardContent } from 'shared/mui/Card/CardContent/CardContent';

export const CardContentStyled = styled(CardContent)({
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
});
